import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import PrivateTextInput from "../Common/PrivateTextInput";

const PasswordAuthentication = (props) => {
    const handleEmailChange = (e) => {
        props.onEmailChange?.(e.target.value);
    };

    const handlePasswordChange = (e) => {
        props.onPasswordChange?.(e.target.value);
    };

    return (
        <>
            <TextField
                type="email"
                label="Email"
                value={props.email ?? ""}
                required
                fullWidth
                autoFocus
                autoComplete="username"
                onChange={handleEmailChange}
                style={{ marginBottom: "20px" }}
            />

            <PrivateTextInput
                label="Password"
                value={props.password ?? ""}
                required
                fullWidth
                autoComplete="current-password"
                onChange={handlePasswordChange}
            />
        </>
    );
};

PasswordAuthentication.propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    onEmailChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
};

export default PasswordAuthentication;
